<template>
    <span>
        <criarturma></criarturma>
    </span>
</template>

<script>
import Criarturma from '@/components/Criar-Turma';

export default {
    name: 'cadcriarturma',
    components: {
        Criarturma
    }
};
</script>